var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container pull-right"},[_c('div',{staticClass:"copyright text-center"},[_vm._v("\n      © "+_vm._s(new Date().getFullYear())+" - LiftX Consult\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }